import { Component, computed, input } from '@angular/core';

import { ReplaceCharPipe } from '@pipe/replace-char.pipe';
import { TimeFromNowPipe } from '@pipe/time-from-now.pipe';
import { Notification, NotificationTypes } from '@type/notification.type';

@Component({
  selector: 'app-notification-block',
  imports: [
    ReplaceCharPipe,
    TimeFromNowPipe,
  ],
  templateUrl: './notification-block.component.html',
  styleUrl: './notification-block.component.scss',
})
export class NotificationBlockComponent {
  notification = input.required<Notification>();

  useDedicatedIcon = computed(() => [
    NotificationTypes.orderCompleted,
    NotificationTypes.downtime,
    NotificationTypes.emergency,
    NotificationTypes.vinUndeliverable,
    NotificationTypes.vanAssignedToOrder,
  ].includes(this.notification().type));

}
